import { useGetIntegrationServiceIdConnectionList } from '@/config/integrations/integrationserviceidconnection/client';
import { usePerms } from '@/hooks/usePerms';
import { VerificationConfig } from '@pigello/pigello-matrix';

export function useIndeterminateVerifications() {
  const { canView: canViewVerification } = usePerms('verification');
  const { canView: canViewIntegrationServiceIdConnection } = usePerms(
    'integrationserviceidconnection'
  );
  const {
    data: integrationServiceIdConnections,
    isLoading,
    isFetching,
  } = useGetIntegrationServiceIdConnectionList({
    queryParams: {
      page: 1,
      pageSize: 1,
      filters: {
        content_type: {
          noop: VerificationConfig.contentType,
        },
        external_id: { noop: '-' },
      },
    },
    overrideUrl: VerificationConfig.contentType,
    enabled: canViewIntegrationServiceIdConnection && canViewVerification,
  });

  return {
    indeterminateVerifications: integrationServiceIdConnections,
    indeterminateVerificationsCount:
      integrationServiceIdConnections?.meta.total_amount,
    isLoading,
    isFetching,
  };
}
